import { useModuleContext } from '@cognitranlimited/itis-web';
export var productInfoModuleId = Symbol('productInfoModule');
export var useProductInfoModuleContext = function () { return useModuleContext(productInfoModuleId); };
